import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
export class SearchIndividualsRequest extends BaseMessage {
    lastName;
    foreName;
    postCode;
    birthDate;
}
__decorate([
    Field.string({
        description: 'last name of an individual',
        maxLength: 30,
    }),
    __metadata("design:type", String)
], SearchIndividualsRequest.prototype, "lastName", void 0);
__decorate([
    Field.string({
        description: 'forename of an individual',
        maxLength: 30,
    }),
    __metadata("design:type", String)
], SearchIndividualsRequest.prototype, "foreName", void 0);
__decorate([
    Field.string({
        description: 'postcode of an individual',
        maxLength: 8,
    }),
    __metadata("design:type", String)
], SearchIndividualsRequest.prototype, "postCode", void 0);
__decorate([
    Field.string({
        description: 'birth date of an individual',
        maxLength: 8,
    }),
    __metadata("design:type", String)
], SearchIndividualsRequest.prototype, "birthDate", void 0);
export default SearchIndividualsRequest;
//# sourceMappingURL=SearchIndividualsRequest.js.map